import React from 'react';

import { TrailToolbar, TrailList } from 'views/Trail/components';
import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <TrailToolbar />
      <div className={classes.content}>
        <TrailList />
      </div>
    </div>
  );
};
